<script>
import axios from "axios";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients: "",
    };
  },
  methods: {
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="50" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="50" />
              </span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="80" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="80" />
              </span>
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h4">{{ userData.business }} </span>
          <span class="h6">{{ userData.location }} </span>
        </span>
      </div>
      <div class="d-flex">

        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content v-if="0"><i class="fas fa-clipboard"></i> Reports<i
                class="mdi mdi-chevron-down"></i></template>
            <div class="row">
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Sales Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="cashpaymentsreport">Cash Payments</router-link>
                  </li>
                  <li>
                    <router-link to="cashpaymentsreport">Non-Cash Payments</router-link>
                  </li>
                  <li>
                    <router-link to="cashpaymentsreport">Cashier Performance</router-link>
                  </li>
                  <li>
                    <router-link to="personalpaymentsreport">Personal Account Payments</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Stock Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="serviceanalysisreport">Sold Stock</router-link>
                  </li>
                  <li>
                    <router-link to="purchasebysupplierreport">Purchases Per Supplier</router-link>
                  </li>
                  <li>
                    <router-link to="productsdemand">Products on Demand</router-link>
                  </li>
                  <li>
                    <router-link to="pharmacybymonthreport">Monthly Analysis</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Expense Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="expensesreport">All Expenses</router-link>
                  </li>
                  <li>
                    <router-link to="expensesreport">Monthly Analysis</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>
        <!-- Subscription Section -->
        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown variant="black" toggle-class="header-item" right>
            <template v-slot:button-content>
              <i class="fas fa-credit-card"></i> Subscription
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <!-- Subscription items -->
            <div class="p-3 text-center" style="min-width: 200px;">
              <h6 class="font-size-14 mt-0 mb-2">Manage Subscription</h6>
              <ul class="list-unstyled megamenu-list">
                <li><router-link to="subscriptions">Subscriptions</router-link></li>
              </ul>
            </div>
          </b-dropdown>
        </span>
        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content><i class="fas fa-clipboard"></i> Reports<i
                class="mdi mdi-chevron-down"></i></template>

            <div class="row justify-content-center d-flex">
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Pharmacy Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="pharmacypaymentsreport">Pharmacy Payments</router-link></li>
                  <li><router-link to="purchasebysupplierreport">Purchases Per Supplier</router-link></li>
                  <li><router-link to="pharmacypurchasereport">Pharmacy Purchases</router-link></li>
                  <li><router-link to="productsdemand">Products On Demand</router-link></li>
                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Profits Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="productsprofit">Profits Per Product</router-link></li>
                  <li><router-link to="cashiersales">Sale Per Cashier</router-link></li>
                  <li><router-link to="cashiersprofit">Profits Per Cashier</router-link></li>
                  <li><router-link to="productsmargin">Margin Profit</router-link></li>

                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Other Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="workloadbyuserreport">Workload Per User</router-link></li>
                  <li><router-link to="expensesreport">Expenses Report</router-link></li>
                  <li><router-link to="pharmacybymonthreport">Monthly Analysis</router-link></li>
                  <li><router-link to="stockbymonthreport">Stock Analysis</router-link></li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="fas fa-user-tie"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <div class="fs-5 dropdown-item text-start">
            <div class="d-block fw-medium text-info">{{ userData.name }}</div>
            <small style="margin-top:-8px;" class="dropdown-item d-block pb-1 border-bottom">{{ userData.role }}</small>
          </div>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
